// Copyright (c) 2026 Michael F. Kamprath
//
// pwa-register.js -- service worker registration wrapper.
//
// Thin wrapper around vite-plugin-pwa's virtual module. Kept in its own
// file so tests can mock it without importing the virtual module (which
// only exists at build time).

export async function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  try {
    const mod = await import('virtual:pwa-register');
    if (typeof mod.registerSW === 'function') {
      mod.registerSW({
        immediate: true,
        onRegisterError(err) {
          console.warn('[pwa-register] SW registration failed:', err);
        },
      });
    }
  } catch (err) {
    console.warn('[pwa-register] virtual:pwa-register not available:', err?.message);
  }
}
